import { render } from "./ContactInformationBasketStepComponent.vue?vue&type=template&id=1b4edf57&ts=true"
import script from "./ContactInformationBasketStepComponent?vue&type=script&lang=ts"
export * from "./ContactInformationBasketStepComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__